import type { StatusTone } from '@/components/ri/statusTones';

interface AccountStatusMeta {
  label: string;
  tone: StatusTone;
  toneKey: string;
}

export const ACCOUNT_STATUS_META: Record<string, AccountStatusMeta> = {
  Active: { label: 'Active', tone: 'success', toneKey: 'active' },
  Customer: { label: 'Customer', tone: 'success', toneKey: 'active' },
  NonRenewing: { label: 'Non-renewing', tone: 'warning', toneKey: 'pending' },
  Onboarding: { label: 'Onboarding', tone: 'warning', toneKey: 'pending' },
  Trial: { label: 'Trial', tone: 'info', toneKey: 'sent' },
  Future: { label: 'Future', tone: 'info', toneKey: 'sent' },
  Prospect: { label: 'Prospect', tone: 'info', toneKey: 'sent' },
  Lead: { label: 'Lead', tone: 'neutral', toneKey: 'draft' },
  Paused: { label: 'Paused', tone: 'neutral', toneKey: 'draft' },
  Inactive: { label: 'Inactive', tone: 'neutral', toneKey: 'draft' },
  Cancelled: { label: 'Cancelled', tone: 'danger', toneKey: 'rejected' },
};

export function accountStatusBadge(status: string): { value: string; label: string } {
  const meta = ACCOUNT_STATUS_META[status];
  return meta ? { value: meta.toneKey, label: meta.label } : { value: status, label: status };
}

const ACCOUNT_STATUS_FILTER_ORDER = [
  'Active',
  'NonRenewing',
  'Trial',
  'Future',
  'Paused',
  'Cancelled',
  'Onboarding',
  'Customer',
  'Prospect',
  'Lead',
  'Inactive',
] as const;

export const ACCOUNT_STATUS_OPTIONS: { id: string; name: string }[] = ACCOUNT_STATUS_FILTER_ORDER.map(
  (id) => ({ id, name: ACCOUNT_STATUS_META[id].label }),
);

export const ACCOUNT_STATUS_FILTERS = [
  { value: 'all', label: 'All' },
  { value: 'Active', label: 'Active' },
  { value: 'NonRenewing', label: 'Non-renewing' },
  { value: 'Trial', label: 'Trial' },
  { value: 'Onboarding', label: 'Onboarding' },
  { value: 'Cancelled', label: 'Cancelled' },
] as const;

export const CUSTOM_STATUS_TAB = 'custom';

export function statusTabFromIds(ids: string[]): string {
  if (ids.length === 0) return 'all';
  if (ids.length === 1 && ACCOUNT_STATUS_FILTERS.some((f) => f.value === ids[0])) return ids[0];
  return CUSTOM_STATUS_TAB;
}

// A selection made from the filter menu can fall outside the six preset pills. Without a pill to
// carry it the whole control renders unselected while the list is filtered, so the presets get a
// trailing Custom pill that holds the state instead.
export function accountStatusTabs(ids: string[]): { value: string; label: string }[] {
  const presets = ACCOUNT_STATUS_FILTERS.map((f) => ({ value: f.value, label: f.label }));
  return statusTabFromIds(ids) === CUSTOM_STATUS_TAB
    ? [...presets, { value: CUSTOM_STATUS_TAB, label: `Custom (${ids.length})` }]
    : presets;
}
